module.exports = __webpack_public_path__ + "img/客服 (3).3ed428e8.png";